<template>
    <div class="bdoRadios">
        <div class="radio_box">
            <el-radio v-model="least20" label="1" text-color="#2E2E2E" border>Yes</el-radio>
            <el-radio v-model="least20" label="2" text-color="#2E2E2E" border>No</el-radio>
        </div>
    </div>
</template>
<script>
export default {
    name: "BdoRadios",
    props: {
        value: {
            type: [Number,String],
            default: ""
        }
    },
    data () {
        return {
            least20: ''
        }
    },
    created () {
        this.least20 = this.value
    },
    watch: {
        least20:function(val) {
            this.$emit("onClick", val)
        },
        value:function(val) {
            this.least20 = val
        }
    },
}
</script>
<style lang="scss" scoped>
.bdoRadios {
    .radio_box {
        margin-bottom: 40px;
        .el-radio {
            font-family: Nunito;
            color: #2E2E2E;
            height: 48px;
            padding: 13px 16px 0;
            line-height: 22px;
            width: 162px;
            border: 1px solid #99C1E7;
            border-radius: 8px;
            margin-right: 0px;
            ::v-deep.el-radio__input {
                .el-radio__inner {
                border: 1px solid #99c1e7;
                }
                float: right;
                padding-top: 3px;
                &.is-checked .el-radio__inner {
                border-color: #0072d8;
                background: #ffffff;
                &::after {
                    background-color: #0072d8;
                }
                }
                .is-checked .el-radio__inner {
                background: #fd7624 !important;
                border-color: #fd7624 !important;
                }
                ::after {
                width: 8px !important;
                height: 8px !important;
                background-color: #e4e4e4;
                transform: translate(-50%, -50%) scale(1);
                }
            }
            ::v-deep.el-radio__label {
                font-size: 16px;
                padding-left: 0px;
                color: #2E2E2E;
            }
        }
    }
}
</style>